import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ToolTip from '../../ui/ToolTip';

import ShowSuccessToasts from '../../global/successToast';
import ShowErrorToasts from '../../global/errorToast';

import { ResetPasswordSchema } from '../validation';
class LoggedInPasswordResetForm extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { userId, error, onSubmit } = this.props;
    let initialValues = {
      userId: userId,
      oldPassword: '',
      newPassword: '',
      newPasswordConfirm: ''
    }
    let toolTipMessage = "Passwords must meet the following requirements:\n" +
      "\t8 character minimum\n\t1 lower case letter\n\t1 upper case minimum\n" +
      "\t1 numeric character\n\t1 special character";
    return (
      <div >
        <ShowSuccessToasts />
        <ShowErrorToasts />
        {error && (<div className="pl-3 pr-3 error-message">{error.message}</div>)}
        <Formik
          validationSchema={ResetPasswordSchema}
          initialValues={initialValues}
          onSubmit={onSubmit}>
          {({ dirty, isSubmitting }) => (
            <Form>
              <div>
                <div className="fieldgroup">
                  <Field
                    name="oldPassword"
                    type="password"
                    placeholder="Old Password"
                    className="form-control"
                  />
                  <ErrorMessage name="oldPassword" component="div" className="error-message" />
                </div>
                <div className="fieldgroup">
                  <Field
                    name="newPassword" type="password"
                    placeholder="New Password" className="form-control"
                  />
                  <ToolTip position="right" message={toolTipMessage}>
                    <i className="far fa-question-circle"></i>
                  </ToolTip>
                  <ErrorMessage name="newPassword" component="div" className="error-message" />
                </div>
                <div className="fieldgroup">
                  <Field
                    name="newPasswordConfirm" type="password"
                    placeholder="Confirm New Password" className="form-control"
                  />
                  <ErrorMessage name="newPasswordConfirm" component="div" className="error-message"/>
                </div>
              </div>
              <div className="button-row">
                <div className="fieldgroup">
                  {
                    dirty && !isSubmitting
                    ? (<button className="btn btn-primary" type="submit">Change</button>)
                    : (<button disabled={true} className="btn btn-primary" type="submit">Change</button>)
                  }
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }
}

export default LoggedInPasswordResetForm;
